import { Box, Link } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { Typography } from '../new/Typography';

const userRoutes = [
  '/auth/sign-up',
  '/auth/sign-in',
  '/auth/organization',
  '/auth/pending',
  '/auth/reset',
  '/auth/invite',
  '/home',
  '/settings',
  '/privacy',
  '/history',
  '/help',
  '/costs',
];

const routesNotToShow = ['/create-notice/bankruptcy', '/create-notice/341', '/'];

const BkFooter = () => {
  const location = useLocation();

  const currentPath = location.pathname;

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#FFF',
        display: userRoutes.includes(currentPath) ? 'block' : 'none',
        border: '0.0625rem solid #D6D6D6',
        px: (theme) => theme.spacing(2),
        position: userRoutes.includes(currentPath) ? 'fixed' : 'relative',
        width: '100%',
        bottom: '0rem',
        // Above the drawer (10) so the sidebar never covers the footer.
        zIndex: 20,
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          height: '100%',
          alignItems: 'center',
          padding: '0.625rem',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: '0.9375rem',
          }}
        >
          <Typography variant="body2">© Certificate of Service</Typography>
          <Typography variant="body2" sx={{ color: '#1D1B20' }}>
            <Link href="tel:+15093482615" color="#436eb2">
              (509) 348-2615
            </Link>
          </Typography>
          <Typography variant="body2" sx={{ color: '#1D1B20' }}>
            <Link href="mailto:support@certificateofservice.com" color="#436eb2">
              support@certificateofservice.com
            </Link>
          </Typography>
          <Typography variant="body2" sx={{ color: '#1D1B20' }}>
            8:00am - 4:00pm PT
          </Typography>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginRight: '0.625rem',
            gap: '0.9375rem',
          }}
        >
          <Typography variant="body2" sx={{ color: '#1D1B20' }}>
            <Link
              target="_blank"
              rel="noreferrer"
              href="https://www.certificateofservice.com/terms-of-service"
              color="#436eb2"
            >
              Terms of Service
            </Link>
          </Typography>
          <Typography variant="body2" sx={{ color: '#1D1B20' }}>
            <Link
              target="_blank"
              rel="noreferrer"
              href="https://www.certificateofservice.com/privacy-policy"
              color="#436eb2"
            >
              Privacy Statement
            </Link>
          </Typography>
          {/* <Link
            sx={{ color: '#fff', textDecoration: 'underline' }}
            href='/cookies'
          >
            Cookie Policy
          </Link> */}
        </div>
      </div>
    </Box>
  );
};
export default BkFooter;
